var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-bg"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticStyle:{"width":"100%","height":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }